/**
 * Black construction paper, behind the filters: the sidebar, the tablet drawer
 * and the phone's Search and Filter sheet.
 *
 * `public/textures/black-paper.jpg` is an 800px tile cut from
 * `_Dev process/texture_black construction paper.jpg`, with its opposite edges
 * cross-faded so it repeats without a seam. It is drawn at 400px, twice the
 * pixel density, and the colour underneath is the photo's own average, so the
 * panel is the right darkness before the image arrives.
 */
export const PAPER_TEXTURE = {
  backgroundColor: '#1d1c1a',
  backgroundImage: 'url(/textures/black-paper.jpg)',
  backgroundSize: '400px 400px',
} as const;
